import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';

// ============================================================================
// SEARCH FORM CONFIGURATIONS
// ============================================================================

export const STOCK_ALERT_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'skuCode',
    label: 'stock_alert.search_filter.sku_code',
    type: 'searchableDropdown',
    placeholder: 'stock_alert.search_filter.select_sku_code',
    width: '300px',
    showClear: true,
    options: [], // Will be populated dynamically
  },
  {
    key: 'warehouseCode',
    label: 'stock_alert.search_filter.warehouse_name',
    type: 'searchableDropdown',
    placeholder: 'stock_alert.search_filter.select_warehouse_name',
    width: '300px',
    showClear: true,
    options: [], // Will be populated dynamically
  },
  {
    key: 'types',
    label: 'stock_alert.search_filter.type',
    type: 'multiselect',
    placeholder: 'stock_alert.search_filter.select_type',
    options: [
      { label: 'stock_alert.type.low_stock', value: 'LOW_STOCK' },
      { label: 'stock_alert.type.over_stock', value: 'OVER_STOCK' },
    ],
    showClear: true,
    filter: false,
    showSelectAll: false,
    width: '200px',
  },
  {
    key: 'severities',
    label: 'stock_alert.search_filter.severity',
    type: 'multiselect',
    placeholder: 'stock_alert.search_filter.select_severity',
    options: [
      { label: 'stock_alert.severity.low', value: 'LOW' },
      { label: 'stock_alert.severity.medium', value: 'MEDIUM' },
      { label: 'stock_alert.severity.high', value: 'HIGH' },
      { label: 'stock_alert.severity.critical', value: 'CRITICAL' },
    ],
    showClear: true,
    filter: false,
    showSelectAll: false,
    width: '200px',
  },
  {
    key: 'statuses',
    label: 'stock_alert.search_filter.status',
    type: 'multiselect',
    placeholder: 'stock_alert.search_filter.select_status',
    options: [
      { label: 'stock_alert.status.new', value: 'NEW' },
      { label: 'stock_alert.status.resolved', value: 'RESOLVED' },
      { label: 'stock_alert.status.suppressed', value: 'SUPPRESSED' },
    ],
    showClear: true,
    filter: false,
    showSelectAll: false,
    width: '200px',
  },
];

// ============================================================================
// TABLE COLUMN CONFIGURATIONS
// ============================================================================

/**
 * Default column property names for Stock Alert table
 */
export const STOCK_ALERT_DEFAULT_COLUMNS = {
  SKU_CODE: 'skuCode',
  SKU_NAME: 'skuName',
  TYPE: 'type',
  WAREHOUSE_NAME: 'warehouseName',
  CURRENT_STOCK: 'currentStock',
  SEVERITY: 'severity',
  STATUS: 'status',
  CREATION_DATE: 'creationDate',
} as const;

/**
 * Flexible column property names for Stock Alert table
 */
export const STOCK_ALERT_FLEXIBLE_COLUMNS = {
  // No flexible columns
} as const;

/**
 * Action column property name for Stock Alert table
 */
export const STOCK_ALERT_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order for Stock Alert table
 */
export const STOCK_ALERT_DEFAULT_COLUMNS_ORDER: string[] = [
  STOCK_ALERT_DEFAULT_COLUMNS.SKU_CODE,
  STOCK_ALERT_DEFAULT_COLUMNS.SKU_NAME,
  STOCK_ALERT_DEFAULT_COLUMNS.TYPE,
  STOCK_ALERT_DEFAULT_COLUMNS.WAREHOUSE_NAME,
  STOCK_ALERT_DEFAULT_COLUMNS.CURRENT_STOCK,
  STOCK_ALERT_DEFAULT_COLUMNS.SEVERITY,
  STOCK_ALERT_DEFAULT_COLUMNS.STATUS,
  STOCK_ALERT_DEFAULT_COLUMNS.CREATION_DATE,
];

/**
 * Flexible columns array for Stock Alert table
 */
export const STOCK_ALERT_FLEXIBLE_COLUMNS_ORDER: string[] = [];

export const STOCK_ALERT_TABLE_CONFIG: TableColumn[] = [
  {
    label: 'stock_alert.table.sku_code',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.SKU_CODE,
    width: 150,
  },
  {
    label: 'stock_alert.table.sku_name',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.SKU_NAME,
    width: 200,
  },
  {
    label: 'stock_alert.table.type',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.TYPE,
    width: 140,
    type: 'custom',
  },
  {
    label: 'stock_alert.table.warehouse_name',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.WAREHOUSE_NAME,
    width: 180,
  },
  {
    label: 'stock_alert.table.current_stock',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.CURRENT_STOCK,
    width: 150,
    type: 'number',
  },
  {
    label: 'stock_alert.table.severity',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.SEVERITY,
    width: 120,
    type: 'custom',
  },
  {
    label: 'stock_alert.table.status',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.STATUS,
    width: 120,
    type: 'status',
  },
  {
    label: 'stock_alert.table.creation_date',
    prop: STOCK_ALERT_DEFAULT_COLUMNS.CREATION_DATE,
    width: 150,
    type: 'date',
  },
  {
    label: 'stock_alert.table.actions',
    prop: STOCK_ALERT_ACTION_COLUMN.ACTIONS,
    width: 150,
    type: 'actions',
    align: 'center',
  },
];

// ============================================================================
// CONSTANTS
// ============================================================================

export const STOCK_ALERT_DEFAULT_CONFIG = {
  PAGE_SIZE: 20,
} as const;

